function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { getBorderToken, getButtonToken, getTextToken } from "../fundations/palette/colorTokens";
/**
 * @see https://www.figma.com/design/Tb6GgTuIDhCTiA132VuYT5/Ignite-Riddle?node-id=9344-71759&t=HnV1jtEDpKBSq5M6-4
 */ export const ToggleButton = {
    MuiToggleButton: {
        variants: [
            {
                props: {
                    size: "large"
                },
                style: ({ theme })=>_object_spread_props(_object_spread({
                        padding: theme.spacing(1.5, 3)
                    }, theme.typography.textMd), {
                        fontWeight: theme.typography.fontWeightMedium,
                        height: "3rem"
                    })
            },
            {
                props: {
                    size: "medium"
                },
                style: ({ theme })=>_object_spread_props(_object_spread({
                        padding: theme.spacing(1.25, 2.5)
                    }, theme.typography.textMd), {
                        fontWeight: theme.typography.fontWeightMedium,
                        height: "2.75rem"
                    })
            },
            {
                props: {
                    size: "small"
                },
                style: ({ theme })=>_object_spread_props(_object_spread({
                        padding: theme.spacing(1.25, 2.5)
                    }, theme.typography.textSm), {
                        fontWeight: theme.typography.fontWeightMedium,
                        height: "2.5rem"
                    })
            },
            {
                props: {
                    size: "xsmall"
                },
                style: ({ theme })=>_object_spread_props(_object_spread({
                        padding: theme.spacing(1, 2)
                    }, theme.typography.textSm), {
                        fontWeight: theme.typography.fontWeightMedium,
                        height: "2.25rem"
                    })
            },
            {
                props: {
                    size: "2xsmall"
                },
                style: ({ theme })=>_object_spread_props(_object_spread({
                        padding: theme.spacing(0.75, 1.75)
                    }, theme.typography.textSm), {
                        fontWeight: theme.typography.fontWeightMedium,
                        height: "2rem"
                    })
            },
            {
                props: {
                    color: "standard"
                },
                style: ({ theme })=>({
                        color: theme.palette.text.textSecondary,
                        borderColor: getButtonToken("buttonSecondaryBorder", theme),
                        "&.Mui-disabled": {
                            borderColor: getBorderToken("borderDisabled", theme),
                            background: "transparent",
                            color: getTextToken("textDisabled", theme)
                        },
                        "&:hover": {
                            borderColor: getButtonToken("buttonSecondaryBorder", theme),
                            background: getButtonToken("buttonSecondaryHover", theme)
                        },
                        "&:active, :focus, &.Mui-selected": {
                            borderColor: getButtonToken("buttonQuarternaryBorder", theme),
                            background: getButtonToken("buttonTertiary", theme),
                            zIndex: 1
                        },
                        "&.Mui-selected:hover": {
                            background: getButtonToken("buttonTertiaryHover", theme)
                        }
                    })
            }
        ],
        defaultProps: {
            disableRipple: true,
            color: "standard"
        },
        styleOverrides: {
            root: {
                textTransform: "none"
            }
        }
    }
};

//# sourceMappingURL=ToggleButton.js.map